// ==================================
// Store de Autenticacion
// ==================================

import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { Usuario } from '@/tipos';

interface AuthStore {
  usuario: Usuario | null;
  token: string | null;
  refreshToken: string | null;
  isAuthenticated: boolean;
  setAuth: (usuario: Usuario, token: string, refreshToken: string) => void;
  updateToken: (token: string) => void;
  logout: () => void;
}

export const useAuthStore = create<AuthStore>()(
  persist(
    (set) => ({
      usuario: null,
      token: null,
      refreshToken: null,
      isAuthenticated: false,

      setAuth: (usuario, token, refreshToken) =>
        set({
          usuario,
          token,
          refreshToken,
          isAuthenticated: true,
        }),

      updateToken: (token) =>
        set({
          token,
        }),

      logout: () =>
        set({
          usuario: null,
          token: null,
          refreshToken: null,
          isAuthenticated: false,
        }),
    }),
    {
      name: 'alebrijecloud-admin-auth',
      partialize: (state) => ({
        usuario: state.usuario,
        token: state.token,
        refreshToken: state.refreshToken,
        isAuthenticated: state.isAuthenticated,
      }),
    }
  )
);
